import React, { useEffect, useState } from "react";

export default function ScrollProgress() {
  const [pct, setPct] = useState(0);
  useEffect(() => {
    const onScroll = () => {
      const doc = document.documentElement;
      const max = doc.scrollHeight - doc.clientHeight;
      const p = max > 0 ? Math.min(100, Math.max(0, (window.scrollY / max) * 100)) : 0;
      setPct(p);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  return (
    <div
      data-testid="scroll-progress"
      className="fixed top-0 left-0 right-0 h-[3px] z-[55] pointer-events-none"
      style={{
        background: "transparent",
      }}
    >
      <div
        className="h-full"
        style={{
          width: `${pct}%`,
          background: "linear-gradient(90deg, #14401F 0%, #B8D958 60%, #E8A33D 100%)",
          boxShadow: "0 0 10px rgba(184,217,88,0.5)",
          transition: "width 80ms linear",
        }}
      />
    </div>
  );
}
